export enum Alignment {
    Start = 'start',
    Center = 'center',
}

export enum Escape {
    Exit = 'exit',
    Skip = 'skip',
}
